/* Full films and testimonial players load after a deliberate click. The homepage's silent preview is managed separately. */
(() => {
  function setupStories(section) {
    if (section.dataset.mmStoriesReady) return;
    section.dataset.mmStoriesReady = 'true';
    const dialog = section.querySelector('[data-mm-video-dialog]');
    const player = section.querySelector('[data-mm-video-player]');
    const closeButton = section.querySelector('[data-mm-video-close]');
    const externalLink = section.querySelector('[data-mm-video-external]');
    const status = section.querySelector('[data-mm-video-status]');
    const title = dialog?.querySelector('h2');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    let lastTrigger = null;

    function clearPlayer() {
      const video = player.querySelector('video');
      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.load();
      }
      // Removing an iframe also stops its playback and browsing context.
      player.replaceChildren();
      player.classList.remove('is-local-video');
      status.hidden = true;
      status.textContent = '';
    }

    section.querySelectorAll('[data-mm-watch], [data-mm-local-video]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        // Preserve ordinary open-in-new-tab gestures and the no-JavaScript fallback.
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const videoId = trigger.dataset.mmWatch;
        const localVideo = trigger.dataset.mmLocalVideo;
        if (!localVideo && !/^[A-Za-z0-9_-]{11}$/.test(videoId)) return;
        event.preventDefault();
        clearPlayer();
        lastTrigger = trigger;
        externalLink.href = trigger.href;
        if (localVideo) {
          const name = trigger.dataset.mmVideoName || 'Event recap';
          title.textContent = name;
          externalLink.setAttribute('aria-label', `View ${name} on Instagram`);
          const video = document.createElement('video');
          video.controls = true;
          video.playsInline = true;
          video.preload = 'metadata';
          video.setAttribute('aria-label', name);
          if (trigger.dataset.mmPoster) video.poster = trigger.dataset.mmPoster;
          video.src = localVideo;
          video.addEventListener('error', () => {
            status.textContent = 'The video could not load. You can watch the original on Instagram.';
            status.hidden = false;
          });
          player.classList.add('is-local-video');
          player.append(video);
          if (!dialog.open) dialog.showModal();
          closeButton.focus();
          // Playback starts only after this deliberate click; native controls remain available.
          video.play().catch(() => {});
          return;
        }
        const person = trigger.dataset.mmPerson || 'Attendee';
        title.textContent = person;
        externalLink.setAttribute('aria-label', `Watch ${person}'s testimonial on YouTube`);
        const iframe = document.createElement('iframe');
        iframe.title = `${person}'s Masterminders testimonial`;
        iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=0&playsinline=1&rel=0`;
        iframe.allow = 'encrypted-media; picture-in-picture; fullscreen';
        iframe.allowFullscreen = true;
        // YouTube requires a referring origin for embedded playback.
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        iframe.addEventListener('error', () => {
          status.textContent = 'The player could not load. You can watch this video on YouTube.';
          status.hidden = false;
        });
        player.append(iframe);
        if (!dialog.open) dialog.showModal();
        closeButton.focus();
      });
    });

    closeButton.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    // Native dialog handles Escape and confines keyboard focus while it is open.
    dialog.addEventListener('close', () => {
      clearPlayer();
      if (lastTrigger?.isConnected) lastTrigger.focus({ preventScroll:true });
      lastTrigger = null;
    });
    window.addEventListener('pagehide', () => {
      if (dialog.open) dialog.close();
      clearPlayer();
    });
  }

  function initStories(root = document) {
    const sections = '[data-mm-testimonials], [data-mm-event-recap]';
    if (root.matches?.(sections)) setupStories(root);
    root.querySelectorAll(sections).forEach(setupStories);
  }
  initStories();
  document.addEventListener('shopify:section:load', (event) => initStories(event.target));
})();
